export const iconFontAwesomePoliticalScaleUnbalancedFlip = (
	<i className="fa-solid fa-scale-unbalanced-flip"></i>
);
